import firebase from 'firebase/app';
import { firebaseAuth, firestoreDb } from '.';
import { init } from '../graphql/client';
import { getCurrentUserWithBreweries } from '../graphql/users';

export function logout() {
  return firebaseAuth.signOut();
}

export async function getUserBearerToken() {
  return firebaseAuth.currentUser.getIdToken().then(token => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Firebase auth token: ', token);
    } else {
      // Put this in the gobal object so I can easily get access to it
      window.tbAuth = token;
    }
    return token;
  });
}

export async function getUserRecord(uid) {
  const user = await firestoreDb
    .collection('users')
    .doc(uid)
    .get();
  return {
    uid,
    ...user.data()
  };
}

export async function loginWithEmailPassword(email, password) {
  await firebaseAuth.signInWithEmailAndPassword(email, password);
  const token = await getUserBearerToken();
  init(token);
  return await getCurrentUserWithBreweries();
}

export async function updateUserDetails(userUid, details) {
  const currentUser = firebaseAuth.currentUser;
  return currentUser.updateEmail(details.email).then(() =>
    firestoreDb.doc(`users/${userUid}`).set(details, {
      merge: true
    })
  );
}

export function updateUserPassword(userUid, currentPassword, newPassword) {
  return firebaseAuth.currentUser
    .reauthenticateWithCredential(
      firebase.auth.EmailAuthProvider.credential(firebaseAuth.currentUser.email, currentPassword)
    )
    .then(() => firebaseAuth.currentUser.updatePassword(newPassword));
}

export function sendResetEmail(emailAddress) {
  return firebaseAuth.sendPasswordResetEmail(emailAddress);
}



// WEBPACK FOOTER //
// ./src/firebase/auth.js